query allExtFootballTeams(
  $first: Int,
  $offset: Int,
  $filter: FootballTeamMappingFilter,
  ) {
  allFootballTeamMappings(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
      extId
      extRef
      feed
      mappingType
      mappingId
      createdAt
      createdBy
      mappedEntity {
        name
        nodeId
        source
        teamId
      }
    }
    totalCount
  }
}
